import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormControl, FormGroup, HelpBlock, ControlLabel, Col, Row } from 'react-bootstrap';

const SelectInput = ({ attribute, displayName, optional = false, helpText, valueOptions, value, updateFunc }) => (
  <FormGroup id={`cross-channel-${attribute}-input`}>
    <Row>
      <Col lg={4} md={6}>
        <ControlLabel>{displayName}</ControlLabel>
        {
          optional &&
          <span className='cc-p-text'> (optional)</span>
        }
        <FormControl
          componentClass='select'
          onChange={e => updateFunc(e.target.value)}
          value={value}
        >
          <option value={-1} key={-1}>-- Select {displayName} {optional ? '(optional)' : '(Required)'} --</option>
          {
            valueOptions.map(option =>
              <option value={option.value} key={option.value}>{option.displayValue}</option>,
            )
          }
        </FormControl>
      </Col>
    </Row>
    <HelpBlock>{helpText}</HelpBlock>
  </FormGroup>
);

SelectInput.propTypes = {
  attribute: PropTypes.string,
  displayName: PropTypes.string,
  helpText: PropTypes.string,
  optional: PropTypes.boolean,
  valueOptions: ImmutablePropTypes.iterableOf(PropTypes.shape({
    value: PropTypes.string,
    displayValue: PropTypes.string,
  })),
  value: PropTypes.string,
  updateFunc: PropTypes.func,
};

export default SelectInput;
